import { Capability } from "./prompt-types";

export default function CapabilityPill({
  capability,
}: {
  capability: Capability;
}) {
  const getDisplayName = (cap: Capability) => {
    switch (cap) {
      case Capability.VisualQuery:
        return "QUERY";
      default:
        return cap.toUpperCase();
    }
  };

  return (
    <div className="flex flex-row gap-2">
      <div className="font-semibold text-xs p-1 border-1 text-muted-foreground border-muted-foreground rounded-md">
        {getDisplayName(capability)}
      </div>
    </div>
  );
}
